import {Injectable } from '@angular/core';
import {HttpClient, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
import {Observable, of, Subject, throwError} from 'rxjs';
import {retry, catchError} from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class UploadService {
	url=[
	    'https://erisservice7.ecologeris.com/ErisExt/smobile_test/MobileService.svc/SaveXprintPhoto',
    ];
	constructor(private http: HttpClient) {
		//this.srvUrl=this.proUrl;
		//this.srvUrl=this.testUrl;
  }
  uploadPhotoService(fileData:any): Observable<any> {
	let inputJson={
      "aNote":
        {"ordernumber":'20200609005',
        "mLat":"0",
        "mLon":"0",
        "mapkey":0,
        "mText":"",
        "noteid":"",
        "nTag":"",
        "medias":[
          {"mType":"photo","mFId":'12',"mExt":"jpg","includedsurvey":"no","mData":fileData}
        ]
      }
    }
    return this.http.post<any>(this.url[0], inputJson)
			.pipe(
				catchError(this.handleError)
			);
  }
  
  private handleError(error: HttpErrorResponse) {console.log(error)
    let errorMessage='';
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
      errorMessage=`Error:${error.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error.text}`);
        errorMessage=`Error code:${error.status}\nMessage : ${error.message}`; 
    }
    // return an observable with a user-facing error message
    //return [];
     //throwError(
      //'Something bad happened; please try again later.');
      return throwError(errorMessage);
  };
}